import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Grievance} from '../../_services/_modals/grievance.modal';

@Component({
  selector: 'app-casemanager-items',
  templateUrl: './casemanager-items.component.html',
  styleUrls: ['./casemanager-items.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CasemanagerItemsComponent implements OnInit {
  displayedColumns: string[] = ['callerid', 'title'];
  expandedElement: Grievance;
  @Input()
  datasource: any;
  @Input()
  itemtype: string;
  @Input()
  grievances_data: Grievance[] = [];
  constructor() { }

  ngOnInit() {
  }
}
